import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import { getOccupancyStatusData } from "../../../../services/event/dashboard/dashboardServices";


const OccupancyChart = (props) => {
  const { startMonth, endMonth, subDomain } = props;

  const [chartData, setChartData] = useState({
    options: {},
    series: [
      {
        name: "",
        data: [],
      },
    ],
  });

  useEffect(() => {
        const fetchData = async () => {
          try {
            const response = await getOccupancyStatusData(
              {
                sub_domain: subDomain,
                fromDate:startMonth,
                toDate: endMonth,
              });
      
            console.log("Response occupancy :", response); // Log the response data
      
            // Ensure response contains the expected structure
            if (response && Array.isArray(response.series) && response.series.length > 0) {
                setChartData((prevData) => ({
                  ...prevData,
                series: response.series.map((value) => (value)),
                  options: {
                    ...response.options, 
                  },

                }));
              } else {
                console.error("Invalid or missing data in response:", response);
              }
          } catch (error) {
            console.error("Error fetching data:", error);
          }
        };
      
        fetchData();
      }, [subDomain,startMonth,endMonth]);

  return (
    <>
      <Chart
        options={chartData.options}
        series={chartData.series}
        type="radar"
        height={350}
        width="100%" 
      />
    </>
  );
};

export default OccupancyChart;